
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import Card from '../../components/base/Card';

export default function Register() {
  const [formData, setFormData] = useState({
    companyName: '',
    businessNumber: '',
    representative: '',
    email: '',
    phone: '',
    address: '',
    website: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    // 폼 제출 로직
    setTimeout(() => {
      setLoading(false);
      alert('가입 신청이 완료되었습니다. 승인 결과는 이메일로 안내드리겠습니다.');
    }, 2000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="py-12">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">교육기관 가입 신청</h1>
            <p className="text-lg text-gray-600">
              CEIS 플랫폼을 이용하여 간편하게 증명서를 발급하고 관리하세요.
            </p>
          </div>

          <Card>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label="기관명 *"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="교육기관명을 입력하세요"
                  required
                />
                <Input
                  label="사업자등록번호 *"
                  name="businessNumber"
                  value={formData.businessNumber}
                  onChange={handleChange}
                  placeholder="000-00-00000"
                  required
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label="대표자명 *"
                  name="representative"
                  value={formData.representative}
                  onChange={handleChange}
                  placeholder="대표자명을 입력하세요"
                  required
                />
                <Input
                  label="담당자 이메일 *"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="contact@example.com"
                  required
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Input
                  label="연락처 *"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="010-0000-0000"
                  required
                />
                <Input
                  label="홈페이지"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="https://example.com"
                />
              </div>

              <Input
                label="주소 *"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="기관 주소를 입력하세요"
                required
              />

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  기관 소개
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="교육기관의 주요 사업 분야와 특징을 간단히 설명해주세요"
                />
              </div>

              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-sm font-medium text-blue-900 mb-2">
                  <i className="ri-information-line"></i>
                  신청 안내
                </h3>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• 가입 신청 후 1-2일 내에 승인 결과를 이메일로 안내드립니다.</li>
                  <li>• 승인 완료 후 관리자 계정 정보를 별도로 발송해드립니다.</li>
                  <li>• 문의사항이 있으시면 고객지원팀으로 연락주세요.</li>
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <Button type="submit" loading={loading} className="flex-1">
                  <i className="ri-send-plane-line"></i>
                  가입 신청하기
                </Button>
                <Link to="/" className="flex-1">
                  <Button variant="outline" className="w-full">
                    <i className="ri-arrow-left-line"></i>
                    돌아가기
                  </Button>
                </Link>
              </div>
            </form>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
}
